import tableOfContents from "./tableOfContents";
import accordion from "./accordion";

export default function(el) {
    accordion(el, 800);
    tableOfContents(el, "btn-bounded--active");
}
